export default __webpack_public_path__ + "static/media/plusIcon.f69c7519.svg";